import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import OTPInput from "otp-input-react";
export default function RiderRegister() {
  let errorsObj = { otp: "" };
  const [spinnerAccept, setSpinnerAccept] = useState(false);
  const [spinnerVerify, setSpinnerVerify] = useState(false);
  const [errors, setErrors] = useState(errorsObj);
  const [OTP, setOTP] = useState("");
  const history = useHistory();
  const [riderID, setRiderID] = useState("");
  const [name, setName] = useState("");

  const [adharFront, setAdharFront] = useState(null);

  const [adharFrontKey, setAdharFrontKey] = useState(null);

  const [email, setEmail] = useState("");

  const [phoneNumber, setPhoneNumber] = useState("");

  const [stepOne, setStepOne] = useState(true);
  const [stepTwo, setStepTwo] = useState(false);
  useEffect(() => {}, []);
  function onSendOtp(e) {
    e.preventDefault();
    setSpinnerVerify(true);
    let error = false;
    const errorObj = { ...errorsObj };
    if (OTP === "") {
      errorObj.otp = "OTP is Required";
      error = true;
    } else if (OTP.length != 4) {
      errorObj.otp = "Please Enter 4 Digit";
      error = true;
    } else {
      var details = {
        OTP: OTP,
        Phone:phoneNumber
      };
      axios
        .put(Baseurl.baseurl + `/rider/rider-verify-otp`, details)
        .then((response) => {
          if (response.data.status) {
            swal(" Verified successfully", response.data.message, "success", {
              button: "Done",
              timer: 3000,
            });
            setSpinnerVerify(false);
            history.push("/Rider-Applied");
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 3000,
            });
            setSpinnerVerify(false);
          }
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
    }

    setErrors(errorObj);
    if (error) {
      return;
    }
  }
  const onChangePicture = (e, id) => {
    //setUploadId(id);
    if (e.target.files[0] && e.target.files[0].size / 1048576 < 10) {
      if (e.target.files[0]) {
        if (id === "front") {
          setAdharFrontKey(e.target.files[0]);
        }

        const reader = new FileReader();
        reader.addEventListener("load", () => {
          if (id === "front") {
            setAdharFront(reader.result);
          }
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 10MB", "error", {
        button: "Done",
        timer: 2000,
      });
    }
  };

  function submitRiderRegister(e) {
    e.preventDefault();
    setSpinnerAccept(true);
    if (phoneNumber.length === 10) {
      const data = new FormData();
      data.append("image", adharFrontKey);

      data.append("phone", phoneNumber);
      data.append("name", name);
      data.append("email", email);

      var config = {
        method: "post",
        url: `${Baseurl.baseurl}/rider/register-rider`,
        data: data,
      };
      axios(config)
        .then(function (response) {
          if (response.data.status) {
           
            if (response.data.status) {
              setRiderID(response.data.rider._id);
              setStepTwo(true);
              setStepOne(false);
              swal("Sent OTP", response.data.message, "success", {
                button: "Done",
                timer: 1000,
              });
            } else {
              swal("Oops", response.data.message, "error", {
                button: "Done",
                timer: 1000,
              });
            }

            setSpinnerAccept(false);
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 2000,
            });
            setSpinnerAccept(false);
          }
        })
        .catch((err) => {
          // if (err.toString() === "Error: Network Error") {
          //   history.push("/offline");
          // } else {
          //   history.push("/400");
          // }
        });
    } else {
      swal("Oops", "Phone Number Should be 10 digits", "error", {
        button: "Done",
        timer: 2000,
      });
      setSpinnerAccept(false);
    }
  }
  return (
    <Card
      style={{
        color: "white",
        background: "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
      }}
    >
      <Card.Header>
        <Card.Title className="text-white">Register Rider</Card.Title>
        <Card.Title className="text-primary">
          {stepOne ? "Step1" : "Step2"}
        </Card.Title>
      </Card.Header>
      <Card.Body>
        {stepOne && (
          <form
            onSubmit={(e) => {
              submitRiderRegister(e);
            }}
          >
            <div className="row">
              <div className="mt-2 col-sm-3">
                <label>Phone Number</label>
              </div>
              <div className="col-sm-3">
                <input
                  required
                  type="phone"
                  className="form-control"
                  id="val-username"
                  name="val-username"
                  value={phoneNumber}
                  maxLength={10}
                  onChange={(e) => {
                    setPhoneNumber(e.target.value);
                  }}
                  placeholder="Enter Number"
                />
              </div>
              <div className="mt-2 col-sm-3">
                <label>Email (Optional)</label>
              </div>
              <div className="col-sm-3">
                <input
                  type="text"
                  className="form-control"
                  id="val-username"
                  name="val-username"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  placeholder="Enter Email"
                />
              </div>
            </div>
            <div className="row mt-4">
              <div className="mt-2 col-sm-3">
                <label>Name (As Per PAN)</label>
              </div>
              <div className="col-sm-3">
                <input
                  required
                  type="text"
                  className="form-control"
                  id="val-username"
                  name="val-username"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  placeholder="Enter Name"
                />
              </div>
              <div className="col-sm-3">
                <label>
                  Adhar Card
                  <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-3">
                <input
                  className="col-sm-12"
                  id="profilePic"
                  type="file"
                  onChange={(e) => {
                    onChangePicture(e, "front");
                  }}
                />

                {adharFront && (
                  <div
                    style={{
                      marginTop: "5px",
                      width: 180,
                      height: 100,
                      aspectRatio: 1 * 1.4,
                    }}
                    className="col-sm-8"
                  >
                    <img
                      alt=""
                      className="playerProfilePic_home_tile"
                      style={{
                        resizeMode: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                      src={adharFront}
                    />
                  </div>
                )}
              </div>
            </div>

            <></>
            {spinnerAccept ? (
              <div className="text-center mt-4">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <>
                {adharFront && (
                  <div className="text-center mt-4">
                    <input
                      className="btn btn-primary"
                      type="submit"
                      value="submit"
                    />
                  </div>
                )}
              </>
            )}
          </form>
        )}
        <>
          {stepTwo && (
            <form onSubmit={onSendOtp}>
              <div className="form-group"></div>
              <div className="form-group ml-3">
                <OTPInput
                  inputStyles={{
                    width: "50%",
                    height: 68,
                    color: "#135334",
                  }}
                  value={OTP}
                  onChange={setOTP}
                  autoFocus
                  OTPLength={4}
                  otpType="number"
                  disabled={false}
                />
                {errors.otp && (
                  <div className="text-danger fs-12 text-center mt-3">
                    {errors.otp}
                  </div>
                )}
              </div>
              {spinnerVerify ? (
                <div className="text-center">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    Verify
                  </button>
                </div>
              )}
            </form>
          )}
        </>
      </Card.Body>
    </Card>
  );
}
